// extracted by mini-css-extract-plugin
export default {"Blackberry":"#333D47","time":"Gf98b60 G9245dd G81a5ae"};